import { useState } from "react";
import Loading from "../../../components/Genericos/Loading/Loading";
import { BodyNotis, NewCardNoti } from "./localStyle";
const BodyNoti = ({
  data,
  loading,
  handleClickButoon,
  noleidos,
}) => {
  const [historial, showHistorial] = useState(false);

  const handleClick = () => {
    showHistorial(true);
  };

  return (
    <BodyNotis>
      {data && data?.length > 0
        ? data.map((e) => {
            return loading ? (
              <Loading
                dataLoading={true}
                color="c-white"
                descripcion={"Cargando Notificaciones..."}
              />
            ) : (
              <NewCardNoti
                onClick={
                  typeof window.orientation !== "undefined"
                    ? () => handleClickButoon(e.id, e)
                    : () => {}
                }
              >
                <div className="card-container">
                  <div className="card-container-text">
                    <span
                      className="title-noti"
                      dangerouslySetInnerHTML={{ __html: e?.titulo }}
                    />
                    <span
                      className="text-noti"
                      dangerouslySetInnerHTML={{ __html: e?.descripcion }}
                    />
                  </div>
                  <div className="card-container-btnDate">
                    <span className="fecha-noti">{e?.fecha}</span>
                    <button onClick={() => handleClickButoon(e.id, e)}>
                      Ver
                    </button>
                  </div>
                </div>
              </NewCardNoti>
            );
          })
        : ""}
      {!historial && noleidos?.length > 0 ? (
        <span className="historial-btn" onClick={handleClick}>
          Ver historial
        </span>
      ) : noleidos?.length > 0 ? (
        <span className="notifiaciones-previas">Notifiaciones Previas</span>
      ) : (
        ""
      )}
      {historial && noleidos && noleidos?.length > 0
        ? noleidos.map((e) => {
            return (
              <NewCardNoti
                onClick={
                  typeof window.orientation !== "undefined"
                    ? () => handleClickButoon(e.id, e)
                    : () => {}
                }
              >
                <div className="card-container">
                  <div className="card-container-text">
                    <span
                      className="title-noti"
                      dangerouslySetInnerHTML={{ __html: e?.titulo }}
                    />
                    <span
                      className="text-noti"
                      dangerouslySetInnerHTML={{ __html: e?.descripcion }}
                    />
                  </div>
                  <div className="card-container-btnDate">
                    <span className="fecha-noti">{e?.fecha}</span>
                    <button onClick={() => handleClickButoon(e.id, e, true)}>
                      Ver
                    </button>
                  </div>
                </div>
              </NewCardNoti>
            );
          })
        : ""}
    </BodyNotis>
  );
};

export default BodyNoti;
